import { IRecentPlansState } from "../models";
import { IGetRecentPlans } from "../models/recentPlansActions";
import { GET_RECENT_PLANS } from "../types";

export default (recentPlans: IRecentPlansState = null, action: IGetRecentPlans): IRecentPlansState => {
    const { payload } = action;
    switch (action.type) {
        case GET_RECENT_PLANS:
            return {
                plans: payload.data.plans,
            };
        default:
            return recentPlans;
    }
};
